import { useForm } from '@mantine/form';

import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import type { ResponseProjectBlock } from '../../../../../../../../../shared/entities/ResponseProjectBlock';
import { useUpdateResponseProjectBlockMutation } from '../../../../../hooks/useUpdateResponseProjectBlock.hooks';

interface ResponseProjectUpdateBlockFormValues {
  title: string;
  description?: string;
}

interface UseResponseProjectUpdateBlockFromProps {
  block: ResponseProjectBlock;
  onSuccess?: () => void;
}

export function useResponseProjectUpdateBlockForm({
  onSuccess,
  block,
}: UseResponseProjectUpdateBlockFromProps) {
  const { t } = useTranslation('bidResponse');
  const { mutateAsync: updateBlock } = useUpdateResponseProjectBlockMutation(
    block.projectId,
  );

  const form = useForm<ResponseProjectUpdateBlockFormValues>({
    validateInputOnChange: true,
    initialValues: {
      title: block.title,
      description: block.description ?? undefined,
    },
    validate: {
      title: value => validateTitle(value, t),
    },
  });

  const handleSubmit = async (values: ResponseProjectUpdateBlockFormValues) => {
    await updateBlock({
      blockId: block.id,
      payload: {
        ...(values.title && { title: values.title }),
        ...(values.description && { description: values.description }),
      },
    });
    onSuccess?.();
  };

  return { form, handleSubmit };
}

function validateTitle(value: string, t: TFunction<'bidResponse'>) {
  if (!value) {
    return t('projectDetail.createBlock.nameField.error');
  }
  return null;
}
